import Vue from "vue";
import Router from "vue-router";
import tableRoutes from "./tableRoutes";
import itemRoutes from "./itemRoutes";
import { parseQuery, stringifyQuery } from "@/services/queryStringService"
import store from '@/store/store';
import { routeIsPublic } from "@/services/routeService";

Vue.use(Router);

let routes = [
    {
        path: "/",
        name: "home",
        component: () => import("@/features/dashboard/Index.vue"),
    },
    {
        path: "/proposal-snapshot/:id",
        name: "proposalSnapshot",
        component: () => import("@/features/proposals/ProposalSnapshot.vue"),
    },
    {
        path: "/survey-input/:id/:projectId",
        name: "surveyInput",
        component: () => import("@/features/surveys/SurveyInput.vue"),
    },
    {
        path: "/publish-proposal/:proposalId",
        name: "publishProposal",
        component: () => import("@/features/proposals/PublishProposalPage.vue"),
    },
    {
        path: "/survey-acknowledgement",
        name: "success",
        component: () => import("@/features/surveys/Acknowledgement.vue"),
    },
    {
        path: "/publication-history/:proposalId",
        name: "Publication History",
        component: () => import("@/features/proposals/ProposalPublicationHistory.vue"),
    },
    {
        path: "*",
        redirect: "/",
    },
];

routes = routes
    .concat(tableRoutes)
    .concat(itemRoutes);

// Pass the query string and route parameters as props into all routes.
routes.forEach(addProps);

function addProps(r) {
    r.props = route => ({
        ...route.params,
        ...route.query,
        ...r.staticProps
    });

    r.children?.forEach(addProps);
}

const router = new Router({
    mode: "history",
    parseQuery,
    stringifyQuery,
    routes: routes
});

router.beforeEach(async (to, from, next) => {
    let isPublicRoute = routeIsPublic(to);
    await store.dispatch('authentication/loadCompletion');
    let isLoggedIn = store.state.authentication.isLoggedIn;

    // if on a public route and logged in, go to home
    if (isPublicRoute && isLoggedIn) {
        redirect('/', to.path, next);
        return;
    }
    // if not on a public route and not logged in, go to login
    if (!isPublicRoute && !isLoggedIn) {
        await store.dispatch('authentication/login', to.fullPath);
        return;
    }
    next();
});

function redirect(to, currentTo, next) {
    if (currentTo === to) {
        next()
        return;
    }
    next({path: to})
}

export default router;
